import { AppThunk } from '../../../store/rootReducer';
import { getBaseProperties, track } from '../analytics.utils';
import { COMMENT_DIAGNOSTIC } from '../analytics.constants';

export const trackComment =
  (comment: string, analyticsTrack = track): AppThunk =>
  (_, getState) => {
    const baseProperties = getBaseProperties(getState);
    if (baseProperties == null) {
      return null;
    }
    const { ecgId, userId, view } = baseProperties;

    analyticsTrack({
      name: COMMENT_DIAGNOSTIC,
      properties: {
        user_id: userId,
        view,
        ecg_id: ecgId,
        value: comment,
      },
    });
  };
